import React, { useEffect, useRef, useState, useMemo } from "react";
import { DDI_Groups } from "data/ddis";
import { Col, Container, Row } from "react-bootstrap";
import DdiGroup from "./ddi_group";
import ga4 from "react-ga4";
import { useTranslation } from "react-i18next";

const Groups = ({ select }) => {
  const { t, i18n } = useTranslation();
  const groups = DDI_Groups();

  const sortedGroups = useMemo(() => {
    return [...groups].sort((a, b) => {
      const nameA = a?.categoryKey ? t("ddis_common:" + a.categoryKey) : a?.category || "";
      const nameB = b?.categoryKey ? t("ddis_common:" + b.categoryKey) : b?.category || "";
      return nameA.localeCompare(nameB);
    });
  }, [groups, t]);

  const ref = useRef(null);

  const [selectedGroup, setSelectedGroup] = useState(null);

  const unsetGroup = () => {
    ga4.event({
      category: "app-interaction",
      action: "group-close",
      label: selectedGroup,
      group_category: selectedGroup,
    });
    setSelectedGroup(null);
  };
  const onSelectGroup = e => {
    const category = e.target?.getAttribute("data-group") ?? null;
    selectGroup(category);
    ga4.event({
      category: "app-interaction",
      action: "group-open",
      label: category,
      group_category: category,
    });
  };
  const selectGroup = category => {
    setSelectedGroup(category);
    setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }, 200);
  };

  useEffect(() => {
    if (select?.length > 0) {
      selectGroup(select);
      ga4.event({
        category: "app-interaction",
        action: "group-open",
        label: select,
        group_category: select,
      });
    }
  }, [select]);

  const getCategoryName = (group) => {
    return group?.categoryKey ? t("ddis_common:" + group.categoryKey) : group?.category;
  };

  return (
    <Container fluid>
      <Row className="g-3">
        {sortedGroups.map((group, idx) => {
          const categoryName = getCategoryName(group);
          if (selectedGroup && selectedGroup === group?.categoryKey) {
            return (
              <Col xs={12} key={idx}>
                <div
                  className="card-pink-selected d-flex align-items-center justify-content-center flex-column"
                  data-group={group?.categoryKey}
                >
                  <div className="card-header" ref={ref} onClick={unsetGroup}>
                    {categoryName}
                  </div>
                  <div className="card-detail d-flex">
                    <DdiGroup group={selectedGroup} showHeader={false} patientControls="add" groupCategory={selectedGroup} />
                  </div>
                </div>
              </Col>
            );
          } else {
            return (
              <Col sm={6} md={4} lg={3} key={idx}>
                <div
                  className="card-pink d-flex align-items-center justify-content-center"
                  data-group={group?.categoryKey}
                  onClick={onSelectGroup}
                >
                  {categoryName}
                </div>
              </Col>
            );
          }
        })}
      </Row>
    </Container>
  );
};

export default Groups;
